import { Flex, Typography, Form } from "antd";

import { NOTIFICATION_TYPE_ENUM } from "interfaces";
import { observer } from "mobx-react-lite";
import { useNotificationContext } from "providers";
import { useEffect, useState } from "react";
import { useStores } from "stores";
import { DefaultSelect } from "ui";
import { checkDaysPassed, notificationPeriodDays, parseErrorMessage, renderBankOptions } from "utils";
import { DIRECT_PAYMENT_CUSTOMER_LP } from "utils/envConstants";

type Props = {
  showDefaultValue?: boolean;
};
export const BankInfoSelect = observer(({ showDefaultValue = false }: Props) => {
  const { bankAccountsStore, user, bidCard } = useStores();
  const [loading, setIsLoading] = useState(false);
  const { bid } = bidCard;
  const { isSeniorOperator } = user.roles;

  const customerCompanyId =
    isSeniorOperator &&
    checkDaysPassed(bid.created, notificationPeriodDays).isOverDays &&
    bid.contract.direction === "EXP" &&
    !DIRECT_PAYMENT_CUSTOMER_LP &&
    bid.status === "FUNDING";
  const { openNotification } = useNotificationContext();

  const getBankInfoHandler = async () => {
    if (!user.userInfo?.company_id) return;

    setIsLoading(true);
    try {
      await bankAccountsStore.fetchBankAccounts(!customerCompanyId ? user.userInfo.company_id : bid.contract.companyId);
    } catch (e: any) {
      openNotification({
        description: parseErrorMessage(e),
        type: NOTIFICATION_TYPE_ENUM.ERROR,
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getBankInfoHandler();
  }, []);

  return (
    <Flex vertical>
      <Typography.Text strong className="margin-bottom-xs">
        Банковские реквизиты для получения рублевого платежа
      </Typography.Text>
      {(!showDefaultValue || (bankAccountsStore?.defaultAccountId?.id && showDefaultValue)) && (
        <Form.Item
          name="accountId"
          className="full-width"
          initialValue={showDefaultValue && bankAccountsStore.defaultAccountId?.id}
          children={
            <DefaultSelect
              placeholder="Реквизиты"
              disabled={loading}
              size="large"
              onChange={(value) => bankAccountsStore.setSelectedAccountId(value)}
            >
              {renderBankOptions(bankAccountsStore.bankAccounts)}
            </DefaultSelect>
          }
        />
      )}
    </Flex>
  );
});
